import Exchange from "../svgs/Exchange"
import SwapSide from "./SwapSide"
import useSwapParams from "../../hooks/useSwapParams"
import SwapButton from "./SwapButton"
import useSwapTrade from "../../hooks/useSwapTrade"
import { Amount } from "../../packages/currency"
import SwapDetails from "./SwapDetails"
import React, { useEffect } from "react"
import { getTokenInfo } from "../../utils/token"
import useTheme from "../../hooks/useTheme"
import { usePublicClient } from "wagmi"

interface SwapPanelProps {
  amount?: string
  inputToken?: string
  outputToken?: string
}

const SwapPanel: React.FC<SwapPanelProps> = ({
  amount,
  inputToken,
  outputToken,
}) => {
  const {
    amountIn,
    setAmountIn,
    tokenIn,
    tokenOut,
    setTokenIn,
    setTokenOut,
    switchToken,
  } = useSwapParams()
  const { darkMode } = useTheme()
  const publicClient = usePublicClient()

  useEffect(() => {
    setAmountIn(amount ?? "")
  }, [amount])

  useEffect(() => {
    if (inputToken && publicClient) {
      getTokenInfo(inputToken, publicClient).then((res) => setTokenIn(res))
    }
  }, [inputToken])

  useEffect(() => {
    if (outputToken && publicClient) {
      getTokenInfo(outputToken, publicClient).then((res) => setTokenOut(res))
    }
  }, [outputToken])

  const trade = useSwapTrade()

  return (
    <div
      className={`relative p-4 md:p-8 mt-4 rounded-lg md:rounded-[32px] ${
        darkMode
          ? "bg-[#131823] shadow-none"
          : "bg-white shadow-[0_12px_24px_#e2e9f6]"
      }`}
    >
      <SwapSide
        side="From"
        token={tokenIn}
        setToken={setTokenIn}
        amount={amountIn}
        setAmount={setAmountIn}
      />

      <div className="flex items-center w-full justify-center">
        <div
          className={`border w-full ${
            darkMode ? "border-[#202835]" : "border-[#e3e7ee]"
          }`}
        ></div>
        <button
          className={`flex items-center justify-center rounded-full h-10 min-w-10 w-10 border hover:rotate-180 transition-all mx-1 ${
            darkMode ? "border-[#202835]" : "border-[#e3e7ee]"
          }`}
          onClick={switchToken}
        >
          <Exchange className="h-4 w-4 text-[#2f8af5]" />
        </button>
        <div
          className={`border w-full ${
            darkMode ? "border-[#202835]" : "border-[#e3e7ee]"
          }`}
        ></div>
      </div>

      <SwapSide
        side="To"
        token={tokenOut}
        setToken={setTokenOut}
        disabled
        amount={
          trade?.data?.amountOut && tokenOut && amountIn.length > 0
            ? Amount.fromRawAmount(tokenOut, trade.data?.amountOut).toExact()
            : undefined
        }
      />
      <SwapDetails trade={trade} />
      <SwapButton trade={trade} />
    </div>
  )
}

export default SwapPanel
